import React, { useState } from "react"
import { Row, Col, Spin, message, Upload } from "antd"
import { ImportStyled } from "./styled"
import SvgIcon from "src/components/SvgIcon"
import HRService from "src/services/HumanResource"
import dayjs from "dayjs"
import ErrorModal from "./ErrorModal"
import { set } from "lodash"

const { Dragger } = Upload

const ImportModal = ({
  open,
  setRefresh,
  onCancel,
  onOk,
  apiDownloadTemplate,
  apiUploadTemplate,
}) => {
  const [loading, setLoading] = useState(false)
  const [uploadErrors, setUploadErrors] = useState([])
  const [errorModalVisible, setErrorModalVisible] = useState(false)

  // Xử lý upload file thành côngc
  const handleUpload = async file => {
    setLoading(true)
    try {
      const formData = new FormData()
      formData.append("file", file) // Thêm file vào formData

      // Duyệt qua các phần tử của formData để xem nội dung
      // for (let [key, value] of formData.entries()) {
      //   console.log(`${key}:`, value);
      // }
      // Gọi API upload file
      const response = await apiUploadTemplate(formData)

      // Kiểm tra phản hồi từ API
      if (!response?.error) {
        message.success(response?.message)
        onCancel()
        setRefresh(preV => !preV)
      } else {
        setUploadErrors(response?.errors)
        setErrorModalVisible(true)
        message.error(response?.message)
      }
    } catch (error) {
      console.log("error", error)
    } finally {
      setLoading(false)
    }
  }

  // Cấu hình Upload props
  const uploadProps = {
    name: "file",
    multiple: false, // Cho phép upload 1 file tại một thời điểm
    accept: ".xlsx, .xls, .xlsm", // Chỉ chấp nhận các file Excel
    customRequest({ file, onSuccess, onError }) {
      // console.log("file", file);
      // Sử dụng customRequest để upload file qua API
      handleUpload(file)
        .then(() => onSuccess("ok")) // Xử lý thành công
        .catch(err => onError(err)) // Xử lý lỗi
    },

    showUploadList: false, // Ẩn danh sách file đã upload
  }
  const handleDownloadTemplate = async () => {
    try {
      const response = await apiDownloadTemplate() // Gọi API trả về blob

      // respone trực tiếp trả về Blob
      const url = URL.createObjectURL(response)
      const link = document.createElement("a")
      link.href = url
      const date = dayjs().format("DD-MM-YYYY")
      const filename = `Danh_sach_goi_cuoc_nha_mạng_${date}.xlsx`

      link.setAttribute("download", filename) // tên file khi tải về
      document.body.appendChild(link)
      link.click()
      link.remove()
    } catch (error) {
      message.error("Không thể tải file mẫu.")
      console.error("Download template error:", error)
    }
  }
  return (
    <>
      <ImportStyled>
        <Spin spinning={loading}>
          <div style={{ marginBottom: 10 }}>
            Tải file mẫu{" "}
            <span
              onClick={handleDownloadTemplate}
              style={{ color: "#154398", cursor: "pointer" }}
            >
              Tại đây
            </span>
          </div>

          <Dragger {...uploadProps}>
            <Row gutter={20} className="justify-content-center">
              <Col>
                <SvgIcon name="cloud" />
              </Col>
              <Col>
                <span>
                  Kéo thả file đính kèm hoặc{" "}
                  <span style={{ color: "#154398" }}>Chọn File</span>
                </span>
              </Col>
            </Row>
          </Dragger>

          <Row className="box-note pt-15">
            <Col>
              <SvgIcon name="warningCKS" />
            </Col>
            <Col className="ml-10">Lưu ý: Tải lên file.</Col>
          </Row>
        </Spin>
      </ImportStyled>
      <ErrorModal
        uploadErrors={uploadErrors}
        open={errorModalVisible}
        onCancel={() => setErrorModalVisible(false)}
      />
    </>
  )
}

export default ImportModal
